// QL-414 — the range a PDF chart block prints. The flow component offers the
// same three as a toggle the reader switches between; a PDF has no toggle, so
// the designer picks exactly one.

export const T = {
  en_GB: {
    timeRange: "Time range",
    timeRangeHelp: "The range the PDF prints. Same options as the flow component.",
    range1Y: "1 year (quarterly)",
    range5Y: "5 years",
    range10Y: "10 years",
  },
  nb_NO: {
    timeRange: "Tidsrom",
    timeRangeHelp: "Tidsrommet PDF-en viser. Samme valg som flytkomponenten.",
    range1Y: "1 år (kvartalsvis)",
    range5Y: "5 år",
    range10Y: "10 år",
  },
} as const;
